import { useEffect } from 'react';

export function usePostMessage({
  postMessageName,
  handler,
}: {
  postMessageName: string;
  handler: (postMessageName: string, event: MessageEvent) => void;
}) {
  useEffect(() => {
    const handleEvent = (event: MessageEvent) =>
      event.data === postMessageName && handler(postMessageName, event);
    window.addEventListener('message', handleEvent);
    return () => window.removeEventListener('message', handleEvent);
  }, [handler]);

  return null;
}
